<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text">Create New DOT Patient</div>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <v-col lg="4">
            <label>Supporting Township</label>
            <v-select
              :items="townships"
              v-model="supporting_township_id"
              @change="handleSupportingTownship"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="4">
            <label>Patient Name</label>
            <v-select
              v-model="patient"
              :items="townshipPatients"
              item-text="name"
              return-object
              dense
              outlined
            >
            </v-select>
          </v-col>
          <v-col lg="4">
            <label>DRTB Code</label>
            <v-text-field
              type="text"
              :value="patient.reg_unique_code"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Phone</label>
            <v-text-field
              v-model.trim="phone"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Body Weight (KG)</label>
            <v-text-field
              v-model.trim="body_weight"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>DOT Volunteer</label>
            <v-select
              v-model="volunteer_id"
              :items="volunteers"
              item-value="id"
              dense
              outlined
            >
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.code }} ({{ data.item.name }})
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.code }} ({{ data.item.name }})
              </template>
            </v-select>
          </v-col>
          <v-col lg="4">
            <div>
              <div>
                <label>DOT Start Date</label>
                <date-picker
                  @clearDate="dots_startdate = null"
                  :date="dots_startdate"
                  v-model="dots_startdate"
                />
              </div>
            </div>
          </v-col>
          <v-col md="4">
            <label>Use App</label>
            <v-select
              v-model="dots_app_status"
              :items="[
                { value: 1, text: `No` },
                { value: 2, text: `Yes` },
              ]"
              item-text="text"
              item-value="value"
              dense
              outlined
            ></v-select>
          </v-col>        
        </v-row>
        <v-row>
          <v-col md="12">
            <label>DOTS Drugs</label>
            <v-select
              :items="dots_drugs"
              v-model="dots_drugs_input"
              item-text="text"
              item-value="value"
              multiple
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>

        <v-btn class="form-btn" @click="emitData">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { dots_drugs } from '../../../..//services/options'

import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { DatePicker },
  data: () => ({
    patient: {},
    phone:null,
    body_weight:null,
    volunteer_id:null,
    dots_app_status: null,
    dots_startdate: null,
    supporting_township_id:null,
    menu: null,
    dots_drugs,
    dots_drugs_input:[]
  }),
  methods: {
    ...mapActions("InfoData", ["getTownships"]),
    handleSupportingTownship(id){
      this.$store.dispatch('Patient/getPatientsByTownship',{
        township_id:id
      })
    },
    emitData() {
      if (this.checkError()) {
        const data ={
            phone: this.phone,
            body_weight: this.body_weight,
            volunteer_id:  this.volunteer_id,
            patient_id:this.patient.id,
            dots_startdate: this.dots_startdate,
            dots_app_status: this.dots_app_status,
            supporting_township_id: this.admin.township_id,
            dots_drugs:this.dots_drugs_input
        }
        this.$emit("emitData", data);
      }
    },
    checkError() {
      var error = ``;

      if (this.phone == null || this.phone.length == 0)
        error += "Phone is required \n";
      else if (
        this.phone.length != 11 &&
        this.phone.length != 10 &&
        this.phone.length != 9
      )
        error += "Phone is invalid \n";

      if (
        this.body_weight == null ||
        this.body_weight.length == 0
      )
        error += "Body Weight is required \n";
      else if (this.body_weight.length > 2)
        error += "Body Weight should be two digits \n";

      if (
        this.volunteer_id == null ||
        this.volunteer_id.length == 0
      )
        error += "Volunteer is required \n";
      if (
        this.dots_app_status == null ||
        this.dots_app_status.length == 0
      )
        error += "DOTS App Status is required \n";
      if (
        this.dots_startdate == null ||
        this.dots_startdate.length == 0
      )
        error += "DOTS Start Date is required \n";
      else if (
        new Date(this.dots_startdate) <
        new Date(this.patient.treatment_startdate)
      )
        error +=
          "DOTS Start Date should be larger than or equal to treatment startdate \n";

      if (error.length > 0) this.$toast.error(error);

      return error.length == 0 ? true : false;
    },
  },
  computed: {
    ...mapState("InfoData", ["mdrTbRegs", "typeOfTBOpt", "townships"]),
    ...mapState("Volunteer", ["volunteers"]),
    ...mapState("Patient", ["townshipPatients"]),
    ...mapState("Admin", ["admin"]),
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteers");
    this.getTownships();
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
</style>
